const accessReport = {
    INSTALLED_EQUIPMENT_LIST: { name: 'Installed Equipment', path: '/installed-equipment-list' },
    STOCK_REPORT_LIST: { name: 'Stock Report', path: '/stock-report-list' },
    AUDIT_LOG_LIST: { name: 'Audit Log', path: '/audit-log-list' },
    AUDIT_LOG_DETAILS: { name: 'Audit Log Details', path: '/audit-log-details' },
}

export default accessReport;